export default __webpack_public_path__ + "static/media/et-or.3e57424f.svg";